import { formatAchievementInfobox, formatItemInfobox, formatSkinBox, formatIconList } from './printInfoboxes.js';
import { wikiPageLookup } from './wikiQueries.js';
import { core_site } from './mysite.js';


/* Color codes taken from http://gw2wbot.darthmaim.de/smiley/gw2itemsearch.html <3 */
const colorRarity = {
	junk: '#808080',
	basic: '#000000',
	fine: '#4f9dfe',
	masterwork: '#2dc50e',
	rare: '#f4c900',
	exotic:'#fda500',
	ascended: '#fb3e8d',
	legendary: '#800080',
	achievement: '#000000',
}

function constructUserOpts() {
	const searchForm = document.getElementById('searchForm').children[0].children;
	
	const mediaWiki = searchForm.namedItem('mediawiki').checked;
	const searchType = searchForm.namedItem('search_type').value || 'items';
	const disableRequire = searchForm.namedItem('disable_req').checked;
	const disableSet = searchForm.namedItem('disable_set').checked;
	const useHardstuck = searchForm.namedItem('useHardstuck').checked;
	const userSet = searchForm.namedItem('set').value || '';
	const userReq = searchForm.namedItem('release').value || '';
	const userSalvage = searchForm.namedItem('salvage').value || '';
	const limit = searchForm.namedItem('max_entries').value || 50;

	const userOptions = {
		searchType: searchType,
		enableMediawiki: mediaWiki,
		enableRequire: !disableRequire,
		enableSet: !disableSet,
		hardstuck: useHardstuck,
		set: userSet,
		requires: userReq,
		salvage: userSalvage,
		limit: limit,
	};

	return userOptions;
}

function formatItems(data, language) {
	let output = "<div id='boxes'>";
	output += formatItemInfobox(data, language);
	const skinOut = formatSkinBox(data)
	const iconOut = formatIconList(data)
	if (skinOut) output += skinOut;
	output += "</div>";
	if (iconOut) output += iconOut;

	return output
}

function formatAchievements(data, language) {
	let output = "<div id='boxes'>";
	output += formatAchievementInfobox(data, language);

	output += '</div>';

	return output
}

async function loadEntry(details) {
	const entryId = parseInt(details.id);
	const userOptions = constructUserOpts();
	const language = 'en';

	const localApiURL = `${core_site}/gw2w/items/?id=${entryId}&userOpts=${JSON.stringify(userOptions)}`;
	
	const res = await fetch(localApiURL);
	if (res.status !== 200) console.error(`Item lookup returned ${res.status}`);
	
	const data = await res.json();
	if (!data) {
		console.error('Error fetching cache.');
		return;
	} else if(data.Error) {
		return console.error(`Internal api error: ${data.Error}`);
	}

	let entryName;
	if (data.itemInfobox) entryName = data.itemInfobox.wikiName || data.itemInfobox.apiName;
	else if (data.achievementInfobox) entryName = data.achievementInfobox.wikiName;
	const pageExists = await wikiPageLookup(entryName);
	data.pageExists = pageExists;
	data.url = localApiURL;

	let output = '';
	if (userOptions.searchType === 'items') output = formatItems(data, language);
	if (userOptions.searchType === 'achievements') output = formatAchievements(data, language);
	if (userOptions.searchType === 'homestead') output = formatItems(data, language);

	document.getElementById('infoboxes').innerHTML = output;

	// Let's change background color of the clicked element
	details.style.background = "#d9e6f9";
}

export async function loadEntryDebug(details) {
        const entryId = parseInt(details.id);
        //const userOptions = constructUserOpts();
        let userOptions={"searchType":"items","enableMediawiki":true,"enableRequire":true,"enableSet":true,"set":"","requires":"","salvage":"","limit":"50"};
		const language = 'en';

        const res = await fetch(`${core_site}/gw2w/items/?id=${entryId}&userOpts=${JSON.stringify(userOptions)}`);
        if (res.status !== 200) console.error(`Item lookup returned ${res.status}`);

        const data = await res.json();
        if (!data) {
                console.error('Error fetching cache.');
                return;
        } else if(data.Error) {
        }

        let entryName;
        if (data.itemInfobox) entryName = data.itemInfobox.wikiName || data.itemInfobox.apiName;
        else if (data.achievementInfobox) entryName = data.achievementInfobox.wikiName;
		
        const pageExists = await wikiPageLookup(entryName);
        data.pageExists = pageExists;

        let output = '';
        if(data.Error) return "";
		output = formatItems(data, language);
        //if (userOptions.searchType === 'achievements') output = formatAchievements(data, language);

        return output;
}


export function formatNewEntries(values, purge=false) {
	if (!values) return;

	const resList = document.getElementById('searchResults');

	let curDate;
	for (const value of values) {
		const valDate = new Date(value.created);
		const day = valDate.getUTCDate()
		const month = valDate.getUTCMonth() + 1;
		const year = valDate.getUTCFullYear();

		const date = `${year}-${month}-${day}`;
		if (! curDate || curDate != date) {
			const h2 = document.createElement('h2');
			h2.innerHTML = date;
			resList.appendChild(h2);

			curDate = date;
		}

		formatSearchResults([value], purge);
	}
}

export function formatSearchResults(values, purge=true) {
	if (!values) return;

	const resList = document.getElementById('searchResults');
	// First we purge
	if (purge) resList.innerHTML = '';

	for (const value of values) {
		const rarity = value.rarity ? value.rarity.toLowerCase() : 'achievement';

		// Let's create this div the long way around but at least it's clear
		const div = document.createElement('div');
		div.id = value.id;
		div.className = rarity
		div.innerHTML = `(${value.id}) ${value.name}`;
		div.innerHTML += value.level ? ` (${value.level})` : '';
		div.onclick = function () {
			loadEntry(this);
		};
		
		const styles = [
			`color:${colorRarity[rarity]}`,
			'cursor: pointer',
		];
		div.style = styles.join(';');

		resList.appendChild(div);
	}
}
